'use client'

import Link from 'next/link'
import { Globe, Terminal } from 'lucide-react'
import { useLanguage } from '@/contexts/language-context'
import { translations } from '@/lib/translations'

export default function FooterSection() {
  const { language } = useLanguage()
  const t = translations[language]

  return (
    <footer className="bg-surface-container-lowest border-t border-glass-stroke px-6 md:px-grid-margin py-20">
      <div className="max-w-[1440px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-6">
          <h2 className="text-3xl md:text-headline-lg font-bold text-on-surface">YesMan</h2>
          <p className="text-base text-on-surface-variant max-w-sm">{t.footer.tagline}</p>
          <div className="pt-4 flex gap-4">
            <a
              href="https://getyesman.com"
              title="YesMan"
              className="w-10 h-10 rounded-full border border-glass-stroke flex items-center justify-center text-on-surface-variant hover:text-on-tertiary-container transition-colors"
            >
              <Globe className="w-5 h-5" />
            </a>
            <a
              href="https://wa.me/22891000000"
              title="WhatsApp"
              className="w-10 h-10 rounded-full border border-glass-stroke flex items-center justify-center text-on-surface-variant hover:text-on-tertiary-container transition-colors"
            >
              <Terminal className="w-5 h-5" />
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-12">
          <div>
            <span className="font-mono text-hud-label uppercase tracking-widest text-on-tertiary-container block mb-6">
              {t.footer.missionTitle}
            </span>
            <p className="text-xs text-on-surface-variant leading-relaxed">{t.footer.mission}</p>
          </div>
          <div className="flex flex-col gap-4">
            <span className="font-mono text-hud-label uppercase tracking-widest text-on-tertiary-container block mb-2">
              {t.footer.legalTitle}
            </span>
            <Link
              href={`/${language}/privacy`}
              title={t.footer.links.privacy}
              className="font-mono text-hud-label uppercase text-on-surface-variant hover:text-on-tertiary-container transition-colors"
            >
              {t.footer.links.privacy}
            </Link>
            <Link
              href={`/${language}/terms`}
              title={t.footer.links.terms}
              className="font-mono text-hud-label uppercase text-on-surface-variant hover:text-on-tertiary-container transition-colors"
            >
              {t.footer.links.terms}
            </Link>
          </div>
        </div>
      </div>

      <div className="max-w-[1440px] mx-auto mt-16 pt-8 border-t border-glass-stroke flex flex-col md:flex-row items-center justify-between gap-4">
        <span className="font-mono text-[10px] text-on-surface-variant uppercase tracking-widest">
          {t.footer.copyright}
        </span>
        <div className="flex gap-6">
          <Link
            href={`/${language}/privacy`}
            title={t.footer.links.privacy}
            className="font-mono text-[10px] text-on-surface-variant uppercase tracking-widest hover:text-on-surface transition-colors"
          >
            {t.footer.links.privacy}
          </Link>
          <Link
            href={`/${language}/terms`}
            title={t.footer.links.terms}
            className="font-mono text-[10px] text-on-surface-variant uppercase tracking-widest hover:text-on-surface transition-colors"
          >
            {t.footer.links.terms}
          </Link>
        </div>
      </div>
    </footer>
  )
}
